export default __webpack_public_path__ + "static/media/Hyrkanian Sable Shadow-Dasher.7400d3ca.jpg";